import React from "react";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";

interface ShowHidePasswordCardProps {
  isPasswordVisible: boolean;
  handleTogglePasswordVisibility: () => void;
  labelStyle?: string;
}

const ShowHidePasswordCard = ({
  isPasswordVisible,
  handleTogglePasswordVisibility,
  labelStyle,
}: ShowHidePasswordCardProps) => {
  const { i18n, t } = useTranslation();

  return (
    <div
      className={cn(
        "absolute top-0  z-10 flex items-center gap-[10.9px] cursor-pointer",
        i18n.language === "en" ? "right-0" : "left-0"
      )}
      onClick={handleTogglePasswordVisibility}
    >
      {isPasswordVisible ? (
        <EyeOff className="w-6 h-6 text-black-tertiary/80" />
      ) : (
        <Eye className="w-6 h-6 text-black-tertiary/80" />
      )}
      <p className={cn("text-black-tertiary/80 text-lg", labelStyle)}>
        {isPasswordVisible ? t("hide") : t("show")}
      </p>
    </div>
  );
};

export default React.memo(ShowHidePasswordCard);
